import { useIntl } from 'react-intl';

import { Typography } from '@/components/ui/typography';

export function IntegratedChannelsTableHeader() {
  const intl = useIntl();

  const tableHeaders = [
    intl.formatMessage({
      defaultMessage: 'Channel',
      description: 'Header for the channel name',
    }),
    intl.formatMessage({
      defaultMessage: 'Status',
      description: 'Header for the status',
    }),
    intl.formatMessage({
      defaultMessage: 'Actions',
      description: 'Header for the actions',
    }),
  ];

  return (
    <div
      className="border-fx-neutral-200 bg-fx-neutral-50 grid gap-x-4 border-y px-4 py-3.5"
      style={{ gridTemplateColumns: '1fr 1fr 2fr' }}
    >
      {tableHeaders.map(header => (
        <Typography
          variant="subtitle1"
          className="!text-fx-neutral-600"
          key={header}
        >
          {header}
        </Typography>
      ))}
    </div>
  );
}
